module.exports = __webpack_public_path__ + "img/font.53526402.png";